import React, { Component } from 'react'
import Snackbar from 'material-ui/Snackbar';

export default class Message extends Component {


    constructor(props) {
        super(props);
        this.state = {
            open: !!props.message,
            ts: 0,
        };
    }
    

  componentWillReceiveProps = (e) => {
    if (typeof e.ts !== 'undefined')
    {
        var open = e.ts !== this.state.ts;
        this.setState({...this.state, ts: e.ts, open: open });
    }
  }
  handleRequestClose = () => {
    this.setState({
        open: false,
        ts: 0,
    });
  }

  render () {
      if (!this.props.message)
      {
          return null;
      }
    return (
        <Snackbar
            open={this.state.open}
            message={this.props.message}
            autoHideDuration={4500}
            action="stäng"
            onRequestClose={this.handleRequestClose}
            onActionTouchTap={this.handleRequestClose}
            />
        )
    }   
}



// WEBPACK FOOTER //
// ./src/components/Auth/Message.jsx